import { Component, OnInit } from '@angular/core'
import { RequestsService } from '../../_shared/services/requests.service'
import { AuthenticationService } from '../../_services/authentication.service'
import { HelperFunctions } from '../../_shared/utils/helper-functions'

declare var jQuery: any

@Component({
  selector: 'app-fertigation',
  templateUrl: './fertigation.component.html',
  styleUrls: ['./fertigation.component.scss'],
})
export class FertigationComponent implements OnInit {
  constructor(
    private authenticationService: AuthenticationService,
    private requestService: RequestsService,
    private helperFunctions: HelperFunctions
  ) {}

  cropName: string
  countryName: string
  fertigationData: any
  states: any
  message: string
  selectedState: string
  fertigationSchedule: any
  loading: boolean = false
  status: string
  isAdding: boolean = false
  model: any
  scheduleId: string
  isLoadingFertigation: boolean = false
  stageNumber: number
  stageName: string
  singleStageData: any
  isEditing: boolean = false
  isDeleting: boolean = false
  sourceName: string
  singleSourceData: any
  selectedFile: File = null
  fertilizerRecommendation: any
  sourceIndex: number
  nutrientsGroup: number
  varieties: any
  selectedVariety: string
  indiaStates: any
  isCreatingSchedule: boolean
  scheduleExists: boolean
  recomStageData: any
  recomSourceData: any
  selectedLanguage: string

  ngOnInit() {
    let crop = localStorage.getItem('crop_name')
    this.cropName = crop
    const currentUser = this.authenticationService.getCurrentUserValue()
    this.selectedLanguage = localStorage.getItem('selected_language')
    const { country } = currentUser
    this.countryName = country
    this.model = {
      stage_number: '',
      start_day: '',
      end_day: '',
    }
    this.loadIndiaStates()
    this.getFertigationData()
  }

  getFertigationData() {
    this.isAdding ||
    this.isEditing ||
    this.isDeleting ||
    this.isCreatingSchedule
      ? (this.isLoadingFertigation = false)
      : (this.isLoadingFertigation = true)
    this.requestService
      .dash_get(
        `fertigation/${this.countryName}/${this.cropName}/${this.selectedLanguage}`,
        null
      )
      .subscribe(
        (res) => {
          this.isLoadingFertigation = false
          this.fertigationData = res.data
          let states = []
          let varieties = []

          this.fertigationData.map((each) => {
            let uniqueStates = []
            let uniqVarieties = []
            states.push(each.state)
            each.variety ? varieties.push(each.variety) : null

            for (let i = 0; i < varieties.length; i++) {
              if (uniqVarieties.indexOf(varieties[i]) === -1) {
                uniqVarieties.push(varieties[i])
              }
            }
            this.varieties = uniqVarieties
            !this.selectedVariety
              ? (this.selectedVariety = this.varieties[0])
              : null

            for (let i = 0; i < states.length; i++) {
              if (uniqueStates.indexOf(states[i]) === -1) {
                uniqueStates.push(states[i])
              }
            }
            this.states = uniqueStates
            !this.selectedState ? (this.selectedState = this.states[0]) : null

            this.selectedState === each.state &&
            this.selectedVariety === each.variety
              ? ((this.fertigationSchedule = each.fertigation_schedule),
                (this.fertilizerRecommendation =
                  each.fertilizer_recommendation),
                (this.scheduleId = each.id),
                (this.scheduleExists = true))
              : null
          })
          this.sortFertSchedules(this.fertigationSchedule)
          this.changeKey(this.fertilizerRecommendation)
        },
        (err) => {
          this.isLoadingFertigation = false
          this.message = err.error
        }
      )
  }

  onStateOptionSelected(event: any) {
    this.selectedState = event.target.value
    this.scheduleExists = false
    this.fertigationData.map((each) => {
      if (
        this.selectedState === each.state &&
        this.selectedVariety === each.variety
      ) {
        this.fertigationSchedule = each.fertigation_schedule
        this.fertilizerRecommendation = each.fertilizer_recommendation
        this.scheduleId = each.id
        this.scheduleExists = true
      }
    })
    this.sortFertSchedules(this.fertigationSchedule)
    this.changeKey(this.fertilizerRecommendation)
  }

  onVarietyOptionSelected(event: any) {
    this.selectedVariety = event.target.value
    this.scheduleExists = false
    this.fertigationData.map((each) => {
      if (
        this.selectedState === each.state &&
        this.selectedVariety === each.variety
      ) {
        this.fertigationSchedule = each.fertigation_schedule
        this.fertilizerRecommendation = each.fertilizer_recommendation
        this.scheduleId = each.id
        this.scheduleExists = true
      }
    })
    this.sortFertSchedules(this.fertigationSchedule)
  }

  changeKey(recommendedFert: object) {
    recommendedFert
      ? Object.values(recommendedFert).forEach((val) => {
          let values: any = val

          values
            ? (values = values.map((obj) => {
                obj['dose(g/plant)'] || obj['dose(kg/plant)']
                  ? (obj.dose = obj['dose(g/plant)'] || obj['dose(kg/plant)'])
                  : null
                delete obj['dose(g/plant)'] || obj['dose(kg/plant)']
                return obj
              }))
            : null
        })
      : null
  }

  sortFertSchedules(schedule: object) {
    let sortedSchedule: any = []
    schedule
      ? ((sortedSchedule = Object.entries(schedule).sort(
          (a: any, b: any) => a[1]['stage_number'] - b[1]['stage_number']
        )),
        (this.fertigationSchedule = sortedSchedule))
      : null
  }

  changeFile(event) {
    this.selectedFile = <File>event.target.files[0]
  }

  UploadFertigationSchedule(addFertigationDataForm) {
    const formData = new FormData()

    if (this.selectedFile) {
      formData.append(
        'schedule_file',
        this.selectedFile,
        this.selectedFile.name
      )
    }

    this.loading = true
    this.requestService
      .dash_post(
        `fertigation/csv/${this.countryName}/${this.cropName}/${this.selectedLanguage}`,
        formData
      )
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isCreatingSchedule = true
            this.getFertigationData()
            this.helperFunctions.displayAlert(this.message, this.status)
            this.resetUploadSchedule()
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
            this.resetUploadSchedule()
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  resetUploadSchedule() {
    jQuery(document).ready(() => {
      jQuery('#scheduleCsvForm')[0].reset()
      jQuery('#addFertigationDataModal').modal('hide')
      this.selectedFile = <File>null
      this.isCreatingSchedule = false
    })
  }

  createFertigationSchedule(createFertigationDataForm) {
    const formData = new FormData()

    formData.append('state', createFertigationDataForm.state)

    this.requestService
      .dash_post(
        `fertigation/${this.countryName}/${this.cropName}/${this.selectedLanguage}`,
        formData
      )
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isCreatingSchedule = true
            this.getFertigationData()
            this.helperFunctions.displayAlert(this.message, this.status)
            jQuery(document).ready(() => {
              jQuery('#createFertigationDataModal').modal('hide')
              jQuery('#creatscheduleForm')[0].reset()
              this.isCreatingSchedule = false
            })
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  createGrowthStage(addGrowthStageForm) {
    const formData = new FormData()

    formData.append('stage_number', addGrowthStageForm.stage_number)
    formData.append('start_day', addGrowthStageForm.start_day)
    formData.append('end_day', addGrowthStageForm.end_day)
    formData.append('stage_description', addGrowthStageForm.stage_description)

    this.loading = true

    this.requestService
      .dash_post(`fertigation/create/stage/${this.scheduleId}`, formData)
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isAdding = true
            this.getFertigationData()
            this.helperFunctions.displayAlert(this.message, this.status)
            this.closeAddStageModal()
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  closeAddStageModal() {
    jQuery(document).ready(() => {
      jQuery('#addGrowthStagesModal').modal('hide')
      jQuery('#addStageForm')[0].reset()
      this.isAdding = false
    })
  }

  setSingleStageData(data: object) {
    this.singleStageData = data
    this.stageName = this.singleStageData[0].replace(/ /g, '_')
  }

  editGrowthStage(editGrowthStageForm) {
    const formData = new FormData()
    formData.append('stage_number', editGrowthStageForm.stage_number)
    formData.append('start_day', editGrowthStageForm.start_day)
    formData.append('end_day', editGrowthStageForm.end_day)
    formData.append('stage_description', editGrowthStageForm.stage_description)

    this.loading = true

    this.requestService
      .dash_post(
        `fertigation/stage/update/${this.scheduleId}/${this.stageName}`,
        formData
      )
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isEditing = true
            this.getFertigationData()
            this.helperFunctions.displayAlert(this.message, this.status)
            this.closeEditStageModal()
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  closeEditStageModal() {
    jQuery(document).ready(() => {
      jQuery('#editGrowthStagesModal').modal('hide')
      jQuery('#editStageForm')[0].reset()
      this.isEditing = false
    })
  }

  deleteGrowthStage(stageName: string): void {
    this.loading = true
    this.requestService
      .dash_delete(stageName, `fertigation/stage/update/${this.scheduleId}`)
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isDeleting = true
            this.getFertigationData()
            this.helperFunctions.displayAlert(this.message, this.status)
            this.closeDeleteModal()
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
            this.closeDeleteModal()
          }
        },
        (err) => {
          this.loading = false
          this.message = 'Some error occurred. Please try again'
          this.status = 'error'
          this.helperFunctions.displayAlert(this.message, this.status)
          this.closeDeleteModal()
        }
      )
  }

  closeDeleteModal() {
    jQuery(document).ready(() => {
      this.isDeleting = false
      jQuery('#deleteStageModal').modal('hide')
    })
  }

  addSource(addSourceForm) {
    const formData = new FormData()

    formData.append('source', addSourceForm.source)
    formData.append('rate', addSourceForm.rate)
    formData.append(
      'number_of_applications',
      addSourceForm.number_of_applications
    )
    formData.append('application_interval', addSourceForm.application_interval)
    formData.append('nutrients_group', addSourceForm.nutrients_group)
    formData.append('dose_units', addSourceForm.dose_units)
    formData.append('how_to_apply', addSourceForm.how_to_apply)

    this.loading = true

    this.requestService
      .dash_post(
        `fertigation/source/${this.scheduleId}/${this.stageName}`,
        formData
      )
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isAdding = true
            this.getFertigationData()
            this.helperFunctions.displayAlert(this.message, this.status)
            this.closeAddSourceModal()
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  closeAddSourceModal() {
    jQuery(document).ready(() => {
      jQuery('#addSource').modal('hide')
      jQuery('#addSourceForm')[0].reset()
      this.isAdding = false
    })
  }

  setSourceData(stageName: string, sourceName: string, data: any) {
    this.singleSourceData = data
    this.sourceName = sourceName
    this.sourceIndex = this.singleSourceData.source.indexOf(this.sourceName)
    this.nutrientsGroup = this.singleSourceData.nutrients_group
    this.stageName = stageName.replace(/ /g, '_')
  }

  editSource(editSourceForm) {
    const formData = new FormData()

    formData.append('source', editSourceForm.source)
    formData.append('rate', editSourceForm.rate)
    formData.append(
      'number_of_applications',
      editSourceForm.number_of_applications
    )
    formData.append('application_interval', editSourceForm.application_interval)
    formData.append('nutrients_group', editSourceForm.nutrients_group)
    formData.append('dose_units', editSourceForm.dose_units)
    formData.append('how_to_apply', editSourceForm.how_to_apply)

    this.loading = true

    this.requestService
      .dash_post(
        `fertigation/source/update/${this.scheduleId}/${this.stageName}/${this.nutrientsGroup}/${this.sourceName}`,
        formData
      )
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isEditing = true
            this.getFertigationData()
            this.helperFunctions.displayAlert(this.message, this.status)
            jQuery(document).ready(() => {
              jQuery('#editSourceModal').modal('hide')
              this.isEditing = false
            })
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  removeSource(sourceName: string) {
    this.loading = true
    this.requestService
      .dash_delete(
        sourceName,
        `fertigation/source/update/${this.scheduleId}/${this.stageName}/${this.nutrientsGroup}`
      )
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isDeleting = true
            this.getFertigationData()
            this.helperFunctions.displayAlert(this.message, this.status)
            jQuery(document).ready(() => {
              jQuery('#removeSourceModal').modal('hide')
              this.isDeleting = false
            })
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.message = 'Some error occurred. Please try again'
          this.status = 'error'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  loadIndiaStates(): void {
    this.requestService.dash_get(`india/states`, null).subscribe(
      (res) => {
        let indiaStates = []
        res.data.map((each) => {
          indiaStates.push(each.states)
          this.indiaStates = indiaStates
        })
      },
      (err) => {
        this.message = err.error
      }
    )
  }

  createStage(addRecommendationStageForm) {
    const formData = new FormData()
    formData.append(
      'stage_description',
      addRecommendationStageForm.stage_description
    )

    this.loading = true

    this.requestService
      .dash_post(`recommendations/stage/${this.scheduleId}`, formData)
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isAdding = true
            this.getFertigationData()
            this.helperFunctions.displayAlert(this.message, this.status)
            this.closeAddModal()
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  closeAddModal() {
    jQuery(document).ready(() => {
      jQuery('#addRecoStagesModal').modal('hide')
      jQuery('#createStageForm')[0].reset()
      this.isAdding = false
    })
  }

  setStageData(data: object) {
    this.recomStageData = data
    this.stageName = this.recomStageData.key
  }

  editStage(editRecommendationStageForm) {
    const formData = new FormData()
    formData.append(
      'stage_description',
      editRecommendationStageForm.stage_description
    )

    this.loading = true

    this.requestService
      .dash_post(
        `recommendations/stage/edit/${this.scheduleId}/${this.stageName}`,
        formData
      )
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isEditing = true
            this.getFertigationData()
            this.helperFunctions.displayAlert(this.message, this.status)
            jQuery(document).ready(() => {
              jQuery('#editRecoStagesModal').modal('hide')
              jQuery('#updateStageForm')[0].reset()
              this.isEditing = false
            })
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  deleteStage(stageName: string): void {
    this.loading = true
    this.requestService
      .dash_delete(stageName, `recommendations/stage/edit/${this.scheduleId}`)
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isDeleting = true
            this.getFertigationData()
            this.helperFunctions.displayAlert(this.message, this.status)
            jQuery(document).ready(() => {
              this.isDeleting = false
              jQuery('#deleteRecomStageModal').modal('hide')
            })
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.message = 'Some error occurred. Please try again'
          this.status = 'error'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  createRecomSource(addRecomSourceForm) {
    const formData = new FormData()

    formData.append('source', addRecomSourceForm.source)
    formData.append('dose', addRecomSourceForm.dose)
    formData.append('units', addRecomSourceForm.units)

    this.loading = true

    this.requestService
      .dash_post(
        `recommendations/source/${this.scheduleId}/${this.stageName}`,
        formData
      )
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isAdding = true
            this.getFertigationData()
            this.helperFunctions.displayAlert(this.message, this.status)
            jQuery(document).ready(() => {
              jQuery('#addRecomSourceModal').modal('hide')
              jQuery('#createSourceForm')[0].reset()
              this.isAdding = false
            })
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  setRecomSourceData(stageName: string, data: any) {
    this.recomSourceData = data
    this.sourceName = this.recomSourceData.source
    this.stageName = stageName
  }

  updateRecomSource(updateRecomSourceForm) {
    const formData = new FormData()

    formData.append('source', updateRecomSourceForm.source)
    formData.append('dose', updateRecomSourceForm.dose)
    formData.append('units', updateRecomSourceForm.units)

    this.loading = true

    this.requestService
      .dash_post(
        `recommendations/source/edit/${this.scheduleId}/${this.stageName}/${this.sourceName}`,
        formData
      )
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isAdding = true
            this.getFertigationData()
            this.helperFunctions.displayAlert(this.message, this.status)
            jQuery(document).ready(() => {
              jQuery('#editRecomSourceModal').modal('hide')
              this.isEditing = false
            })
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  deleteSource(sourceName: string) {
    this.loading = true
    this.requestService
      .dash_delete(
        sourceName,
        `recommendations/source/edit/${this.scheduleId}/${this.stageName}`
      )
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isDeleting = true
            this.getFertigationData()
            this.helperFunctions.displayAlert(this.message, this.status)
            jQuery(document).ready(() => {
              jQuery('#deleteSourceModal').modal('hide')
              this.isDeleting = false
            })
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.message = 'Some error occurred. Please try again'
          this.status = 'error'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }
}
